import "./DownloadPage.css";

function DownloadPage() {
  return (
    <div className="download-page">
      <div className="download-page__content">
        अहिले कुनै डाउनलोड उपलब्द छैन
      </div>
    </div>
  );
}

export default DownloadPage;
